<template>
  <div
    v-if="mediacontent?.file_content"
    v-html="mediacontent?.file_content"
  />
  <div
    v-if="mediacontent && !mediacontent?.file_content"
    id="popup-content"
    :class="['popup-content', getClassAttributes(mediacontent?.attributes)]"
  >
    <div
      v-if="mediacontent?.popUpTextLinkMap?.eyebrow?.text"
      :class="[mediacontent?.attributes?.eyebrowStyleType, 'eyebrow']"
      v-html="sanitize(mediacontent?.popUpTextLinkMap?.eyebrow?.text, cleanStyles)"
    />
    <div
      v-if="mediacontent?.popUpTextLinkMap"
      class="popup-text"
      v-html="popupContent"
    />
    <Ctas
      class="cta"
      :ctas="mediacontent?.ctas"
      :alignment="mediacontent?.attributes?.alignment"
    />
  </div>
</template>

<script setup>
import {
  computed,
} from 'vue';
import { sanitize } from '@vue-util/sanitize';
import cleanStyles from '../../helpers/getCleanStyles';
import Ctas from '../ctas';
import { getClassAttributes } from '../../helpers/getAttributes';

const props = defineProps({
  mediacontent: {
    type: Object,
    default: () => {},
  },

  popupArray: {
    type: Array,
    default: () => [
      'heading',
      'body',
      'subHeading',
      'body2',
      'subHeading2',
      'body3',
      'subHeading3',
      'body4',
      'subHeading4',
      'subBody',
    ],
  },
});

const popupContent = computed(() => {
  let popupData = '';
  const popupAttributes = props.mediacontent?.popUpTextLinkMap;
  props.popupArray
    .filter((key) => key in popupAttributes)
    .forEach((e) => {
      if (popupAttributes[e].text) {
        popupData += `<div class="${e}"> ${popupAttributes[e].text} </div>`;
      }
    });
  return sanitize(popupData, cleanStyles);
});

const align = computed(() => {
  const alignMap = {
    left: 'flex-start',
    right: 'flex-end',
    center: 'center',
  };
  return alignMap[props.mediacontent?.attributes?.alignment] || 'flex-start';
});

const fontColor = computed(() => (props.mediacontent?.attributes?.fontColor
  ? props.mediacontent.attributes.fontColor
  : 'inherit'));

</script>

<style lang="scss" scoped>
.popup-content {
  display: flex;
  justify-content: center;
  flex-direction: column;
  color:v-bind(fontColor);
  align-items:v-bind(align);
  margin-top: rem-calc(8px);
}

.popup-content  :deep(*) {

  .popup-text, .eyebrow{
    *{
    color: v-bind(fontColor);
    }
  }
  .subHeading,
  .subHeading2,
  .subHeading3, .subHeading4, .subBody {
    margin-top: rem-calc(16);
  }
  .ctas-cont {
    margin-top: rem-calc(16);
  }
}
</style>

<style lang="scss" brand="mcom" scoped>
.popup-content {
  :deep() {
    .eyebrow + .popup-text .heading {
      margin-top: rem-calc(4px);
    }
    .body, .body2, .body3, .body4 {
      margin-top: rem-calc(8);
    }
  }
}
</style>

<style lang="scss" brand="bcom" scoped>
@import "./../../scss/app.bcom.scss";
.popup-content {
  :deep() {
    .eyebrow + .popup-text .heading {
      margin-top: rem-calc(16px);
    }
    .body {
      margin-top: rem-calc(8px);
    }
    .body2, .body3, .body4 {
      margin-top: rem-calc(4);
    }
  }
  @include breakpoint(large) {
    :deep() {
      .ctas-cont {
        margin-top: rem-calc(32px);
      }
    }
  }
}
.boxedEyebrow {
  display: inline-block;
  color: $white;
  background-color: $black;
  padding: rem-calc(8);
}

.eyebrow.boxedEyebrow  :deep(*){
  color: $white;
}
</style>
